import { render, staticRenderFns } from "./ConfigurazioneContabilitaMetodiPagamentoListPage.vue?vue&type=template&id=31d91f69"
import script from "./ConfigurazioneContabilitaMetodiPagamentoListPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneContabilitaMetodiPagamentoListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports